export default [
  {
    path: "/bloqueioPrefeituras",
    name: "BloqueioPrefeitura",
    component: () => import("../views/index"),
    meta: { requiresAuth: true },
  },
];
